export default "__VITE_ASSET__B$TCW86s__"